import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export function CollegeCurrentSchoolInternationalRegion({
  label = "Current School State/Province/Region",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: "college-current-school-address-international-region",
        type: "textfield",
        name: "college-current-school-address-international-region",
        label: label,
        validate: {
          presence: true,
        },
        dependent: {
          dependentName: "college-current-school-address-country",
          condition: "notequal",
          conditionValue: "United States",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
